'use client';

import { ConfirmDialogProvider } from '@/components/confirm/ConfirmDialogProvider';
import ToastHost from '@/components/layout/ToastHost';
import { CartProvider } from '@/features/checkout/CartProvider';
import { ThemeProvider } from 'react-bootstrap';

export default function Providers({ children }) {
  return (
    <CartProvider>
      <ThemeProvider
        breakpoints={[
          'xs',
          'xxs',
          'msm',
          'sm',
          'mmd',
          'md',
          'mlg',
          'xmlg',
          'lg',
          'mxl',
          'landscape',
          'xl',
          'xxl',
        ]}
        minBreakpoint="xs"
      >
        {/* ToastHost portals into document.body — must live here (inside a
            stable Client root) so it survives navigation without remounting */}
        <ToastHost />
        <ConfirmDialogProvider>{children}</ConfirmDialogProvider>
      </ThemeProvider>
    </CartProvider>
  );
}
